import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { typeList } from '../../insurance/templateManage/request.js';
import { displaysOptionData, newStoreLibrary, getLibraryDetail, editLibrary } from './request';
export default {
  data() {
    return {
      form: {
        addWay: 'HAND_MOVEMENT'
      },
      continueState: false,
      loading: false,
      typeList: typeList,
      displaysOptionData: displaysOptionData,
      radioStyle: {},
      dirctionaryObj: null
    };
  },
  computed: {
    ruleData() {
      return {
        addWay: [{
          required: true,
          message: this.$t('请选择') + this.$t('新增方式'),
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('字段名称'),
          trigger: 'blur'
        }, {
          min: 2,
          max: 50,
          message: this.$t('至少输入2个字符,最多输入50个字符'),
          trigger: 'blur'
        }],
        field_category: [{
          required: true,
          message: this.$t('请选择') + this.$t('字段分类'),
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('模板类型'),
          trigger: 'change'
        }],
        code: [{
          required: true,
          message: this.$t('请输入') + this.$t('标识'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('至少输入1个字符, 最多输入100个字符'),
          trigger: 'blur'
        }],
        description: [{
          required: false,
          max: 20,
          message: this.$t('最多输入20个字符'),
          trigger: 'blur'
        }],
        remark: [{
          required: false,
          max: 20,
          message: this.$t('最多输入20个字符'),
          trigger: 'blur'
        }],
        display: [{
          required: true,
          message: this.$t('请选择') + this.$t('控件'),
          trigger: 'change'
        }],
        lengthLimit: [{
          required: true,
          validator: this.validateLength,
          trigger: 'blur'
        }],
        displayType: [{
          required: true,
          message: this.$t('请选择') + this.$t('控件类型'),
          trigger: 'change'
        }],
        formatStyle: [{
          required: true,
          message: this.$t('请选择') + this.$t('格式'),
          trigger: 'change'
        }]
      };
    }
  },
  created() {
    const id = this.$route.params.id;
    if (id != -1) {
      //编辑字段
      this.$route.meta.title = this.$t('编辑字段');
      getLibraryDetail({
        id
      }).then(res => {
        this.form = {
          name: res.name,
          code: res.code,
          addWay: res.addWay,
          type: res.type ? res.type : undefined,
          field_category: res.field_category,
          display: res.display,
          description: res.description,
          remark: res.remark
        };
        if (this.form.display === 'SINGLE_ROW' || this.form.display === 'MULTILINE') {
          this.$set(this.form, 'lengthLimit', res.expand);
        }
        if (this.form.display === 'SELECT') {
          let expandObj = JSON.parse(res.expand);
          let expand = res.custom && res.custom == 4 ? res.custom : res.expand;
          this.dirctionaryObj = res.custom && res.custom == 4 ? expandObj : null;
          this.$set(this.form, 'displayType', String(expand));
        }
        if (this.form.display === 'TIME') {
          this.$set(this.form, 'formatStyle', res.expand);
        }
        if (this.form.display === 'IMG') {
          this.$set(this.form, 'other', res.expand);
        }
      });
    } else {
      // 新增传递的id是-1
      this.$route.meta.title = this.$t('新增字段');
    }
  },
  methods: {
    validateLength(rules, value, callback) {
      if (!value && value !== 0) {
        callback(new Error(this.$t('请输入') + this.$t('长度限制')));
      }
      if (value && (Number(value) > 200 || Number(value) < 1)) {
        callback(new Error(this.$t('请输入“1-200”范围内数字')));
      }
      callback();
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = {
            name: this.form.name,
            code: this.form.code,
            addWay: this.form.addWay,
            field_category: this.form.field_category,
            display: this.form.display,
            description: this.form.description || '',
            remark: this.form.remark || ''
          };
          if (this.form.field_category === 'insurance_template') {
            params.type = this.form.type;
          }
          if (this.form.display === 'SINGLE_ROW' || this.form.display === 'MULTILINE') {
            //转换成字符串
            params.expand = this.form.lengthLimit + '';
          }
          if (this.form.display === 'SELECT') {
            params.expand = this.form.displayType + '';
          }
          if (this.form.display === 'TIME') {
            params.expand = this.form.formatStyle + '';
          }
          if (this.form.display === 'IMG') {
            params.expand = this.form.other == 1 ? '1' : '2';
          }
          if (this.$route.params.id != -1) {
            //编辑保存
            params.id = this.$route.params.id;
            if (params.expand === '4') {
              params.custom = params.expand;
              params.expand = this.dirctionaryObj ? JSON.stringify(this.dirctionaryObj) : JSON.stringify({});
            }
            this.loading = true;
            editLibrary(params).then(res => {
              this.loading = false;
              if (res.id) {
                this.$message.success(this.$t('编辑成功'));
                this.$router.push({
                  name: 'fieldLibrary'
                });
              }
            }).catch(() => {
              this.loading = false;
            });
          } else {
            //新增字段保存
            this.loading = true;
            newStoreLibrary(params).then(res => {
              this.loading = false;
              if (res.id) {
                this.$message.success(this.$t('保存成功'));
                if (this.continueState) {
                  this.$refs.form.resetFields();
                } else {
                  this.$router.push({
                    name: 'fieldLibrary'
                  });
                }
              }
            }).catch(() => {
              this.loading = false;
            });
          }
        }
      });
    },
    getTemplateSelectOption(value) {
      if (value === 'claims_param') {
        this.$set(this.form, 'type', undefined);
      }
    },
    displayChange(value) {
      if (value === 'SINGLE_ROW' || value === 'MULTILINE') {
        this.$set(this.form, 'formatStyle', '');
        this.$set(this.form, 'displayType', '');
      }
      if (value === 'SELECT') {
        this.$set(this.form, 'formatStyle', '');
        this.$set(this.form, 'lengthLimit', '');
      }
      if (value === 'TIME') {
        this.$set(this.form, 'displayType', '');
        this.$set(this.form, 'lengthLimit', '');
      }
    }
  }
};